import React from 'react';
import ButtonsGeneric from '../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputCheckBox from '../../../../../../components/NovoSistema/InputCheckBox';
import InputDate from '../../../../../../components/NovoSistema/InputDate';
import InputText from '../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function ConciliacaoBancariaAdd({ setOption }) {
  return (
    <ContainerSection>
      <div>
        <h3>Lançamento em Conta</h3>
        <WrapperInputsNewSystem>
          <InputText title="*Número" id="NumeroConciliacao" widthPercentage="45%" />
          <InputText title="*Origem" id="OrigemConciliacao2" widthPercentage="45%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="*Doc.Rec./Pag." id="DocPagConciliacao" widthPercentage="45%" />
          <InputDate title="*Data de Cadastro" id="DataCadastroConciliacao" widthPercentage="45%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="*Natureza" id="NaturezaConciliacao" widthPercentage="45%" />
          <InputText title="*Valor" id="ValorConciliacao" widthPercentage="45%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <SelectAndOptions
            title="Conta bancária"
            id="ContaBancariaConciliacao2"
            optionsArray={['']}
            widthPercentage="45%"
          />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="Histórico" id="HistoricoConciliacao3" widthPercentage="45%" />
          <SelectAndOptions
            title="Forma de Pagamento"
            id="FormaPagamentoConciliacao"
            optionsArray={['', 'Dinheiro']}
            widthPercentage="45%"
          />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputCheckBox title="*Taxa Administrativa" id="TaxaAdministrativaConciliacao" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputCheckBox title="Integrar com o Contábil" id="TaxaAdministrativaConciliacao" />
          <SelectAndOptions title="Categoria" id="CategoriaConciliacao" optionsArray={['']} widthPercentage="45%" />
        </WrapperInputsNewSystem>
      </div>
      <ButtonsGeneric>
        <button className="success">Salvar</button>
        <button className="error" onClick={() => setOption('search')}>
          Retornar
        </button>
      </ButtonsGeneric>
      <WrapperInputsNewSystem>
        <span>{' * '} Campo de preenchimento obrigatório</span>
      </WrapperInputsNewSystem>
    </ContainerSection>
  );
}
